import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Notification from './../basics/Notification';
import ProductTerms from './ProductTerms';
import ProductMap from './ProductMap';
import ProductRelated from './ProductRelated';
import parse from 'html-react-parser';

import { useEffect, useState } from 'react';
import { useParams,useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: any[]; // Define the type of 'dataLayer' property here if possible
  }
}

const ProductDetail = () => {

  const { pathname } = useLocation();

  const services = new Services();

  let {id} = useParams();

  let firstImage = '';

  const [product, setProduct] = useState<any>(null);

  const [isPrivate, setIsPrivate] = useState<any>(false);

  const [productName, setProductName] = useState<any>();

  const [productPriceBase, setProductPriceBase] = useState<any>(0);

  const [productPrice, setProductPrice] = useState<any>(0);

  const [bigImage, setBigImage] = useState<any>();

  const [notification, setNotification] = useState<any>();

  const [images, setImages] = useState([]);

  const [propositions, setPropositions] = useState([]);

  const [places, setPlaces] = useState([]);

  const [selectedPlace, setSelectedPlace] = useState<any>({latitude: 0, longitude: 0});

  const [selectedPlaceName, setSelectedPlaceName] = useState<any>('');

  const [placeNotSelected, setPlaceNotSelected] = useState<boolean>(true);

  const [idProductPlace, setProductPlace] = useState("");

  const [count, setCount] = useState<any>('1');

  const gallery: any[] = [];

  const propsList: any[] = [];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  useEffect(()=>{

    services.getProduct(id).then( (value: any) => {

      console.log(value)
      setProduct(value)
      setProductPrice(value.price)
      setProductPriceBase(value.price)
      setImages(value.attachment)
      setPropositions(value.additionalText)
      setIsPrivate(value.isPrivate)

    });

    services.getProductPlaces().then( (value: any) => {

      setPlaces(value)

      let placeOptions = 0

      if(id === '1'){
       placeOptions = 0
      }
      if(id === '2'){
       placeOptions = 1
      }
      if(id === '3'){
       placeOptions = 7
      }
      if(id === '5'){
       placeOptions = 8
      }
      if(id === '31'){
       placeOptions = 1
      }

      // setSelectedPlace({latitude: value[placeOptions].latitude, longitude: value[placeOptions].longitude})

      // setProductPlace(value[placeOptions].name)

      // setSelectedPlaceName(value[placeOptions].name)

    });

  }, [ id ])

  useEffect(()=>{

    if(isPrivate){
      setSelectedPlace({latitude: 0, longitude: 0})
    }

  }, [ isPrivate ])

  useEffect(()=>{

    setBigImage(firstImage)

  }, [ product ])

  const submitForm = (event: any) => {

    event.preventDefault();

    let orderId: any = localStorage.getItem('orderId');

    services.addToCart(orderId, product.id, event.target.place.value, event.target.count.value ).then( (value: any) => {

    });

    setNotification(<Notification text={ "Produkt "+product.name+" byl přidán do košíku"} link="/cart" linkText="Zobrazit košík"/>)
    
    if (window.dataLayer) {

      window.dataLayer.push({ ecommerce: null });

      window.dataLayer.push(
      {
        event: "add_to_cart",
        ecommerce: {
          currency: "CZK",
          value: product.price*event.target.count.value,
          items: [
            {
              item_id: product.id,
              item_name: product.name,
            }
          ]
        }
      });
    } else {
      console.error("window.dataLayer is not defined.");
    }
    
  }

  useEffect(()=>{

    setProductPrice( productPriceBase * count )

  }, [ count ])

  const selectPlace = (event: any) => {

    console.log(event)

    const idx = event.target.selectedIndex;
    const option = event.target.querySelectorAll('option')[idx];
    const newLatitude = option.getAttribute('data-lat');
    const newLongitude = option.getAttribute('data-long');

    let newSelectedPlace = {latitude: newLatitude, longitude: newLongitude}

    // console.log(newSelectedPlace)

    setSelectedPlace(newSelectedPlace)

    setSelectedPlaceName(event.target.value)

    setProductPlace(event.target.value)

    setPlaceNotSelected(false);

  }

  const inputPlace = (event: any) => {

    console.log(event)

  }

  let first:boolean = true;
  let firstAddress:string = '';

  images.forEach((data: any) => {

    let address = 'http://api-balony.techcrowd.space/'+data.path;

    if( first ){ firstImage = address }
    gallery.push(<div className="col-3 rounded-4 img-container-1-1 img-container scale-hover" onClick={ () => setBigImage(address) }><img className="rounded-4" src={address}/></div>)

    first = false;

  })

  propositions.forEach((data: any) => {

    propsList.push(<div className="fs-5 text-secondary fw-normal"><i className="text-primary fa-solid fa-check me-2"></i> {data.text}</div>)

  })

  const placesList: any[] = [];

  first = true;

  let firstPlace = {latitude: 0, longitude: 0}

  places.forEach((data: any) => {

    let placeOptions = Array();

    if(id === '1'){
     placeOptions = [3,4,2,1,9,10,12,19,20]
    }
    if(id === '2'){
     placeOptions = [3,4,2,1,9,10,12,19,20]
    }
    if(id === '3'){
     placeOptions = [14]
    }
    if(id === '5'){
     placeOptions = [15,16,17,18]
    }
    if(id === '31'){
     placeOptions = [15,16,17,18]
    }

    // if( first && placeOptions.includes(data.id)){
    //   placesList.push(<option value={data.name} data-lat={data.latitude} data-long={data.longitude} selected>{data.name}</option>)
    // }

    if(placeOptions.includes(data.id)){
      placesList.push(<option value={data.name} data-lat={data.latitude} data-long={data.longitude}>{data.name}</option>)
    }

    first = false;
  })

  let breadcrumbs = [

    {'name':'Obchod', 'link':'/', 'active': true},
    {'name': id,'link': id, 'active': false}

  ];

  if( product !== null ){

    breadcrumbs = [

      {'name':'Obchod', 'link':'/', 'active': true},
      {'name': product.name,'link': product.name, 'active': false}

    ];

  }

  function ShopForm(props: any) {
    if (!props.warn) {
      return (
        <div className="mb-3 row">
          {placeNotSelected && (<div className='text-danger'><small>Místo letu musí být vybrané</small></div>)}
          <label htmlFor="staticEmail" className="col-auto col-form-label"><strong>Vyberte místo vzletu</strong></label>
          <div className="col-auto">
            <select onChange={(e) => selectPlace(e)} name="place" className="form-control form-select mb-3 border-0" aria-label="form-select-lg" value={selectedPlaceName}>
              {placeNotSelected && (<option value="" data-lat="" data-long="">Zvolte místo</option>)}
              {placesList}
            </select>
          </div>
          <div><i className="fa-solid fa-circle-info text-primary"></i><small> Při rezervaci si můžete vybrat jakékoli místo vzletu ze seznamu</small></div>
        </div>
      );
    }

    return (
      <div className="mb-3 row">
        <label htmlFor="staticEmail" className="col-auto col-form-label"><strong>Předpokládané místo vzletu</strong></label>
        <div className="col-auto">
          <input type="text" name="place" className="form-control mb-3 border-0 form-control-bg" placeholder="Místo vzletu" required/>
        </div>
      </div>
    );
  }

  function Relations(props: any) {
    if (!props.private) {
      return (
        <ProductRelated id={id}/>
      );
    }

    return (
      <ProductRelated type="private" id={id}/>
    );
  }

  function ProductBase(props: any) {
    if (!props.private) {
      return (
        <small className="text-secondary">
            Cena {productPriceBase} Kč / osoba
        </small>
      );
    }

    return (
      <small className="text-secondary"></small>
    );
  }

  function TermsList(props: any) {
    if (!props.private) {
      return (
        <ProductTerms id={props.id}/>
      );
    }

    return (
      <div></div>
    );
  }

  return (

    <div>

    <div id="top" className="product container mt-5 pt-5">

      {notification}

      <Breadcrumb links={breadcrumbs} />

      <div className="row mb-5 pb-5">

        <div className="col-12 col-lg-6">
          <div className="col-12 rounded-5 img-container-4-3 img-container mb-3"><img src={bigImage} className="col-12 rounded-5"/></div>
          <div className="row g-3">{gallery}</div>
        </div>

        <div className="col-12 col-lg-6 ps-lg-5 ">

          <div className="row mb-4 mt-3 mt-lg-0">
            <div className="col-2 col-lg-1 pt-1">
              <i className="fa-2xl fa-solid fa-ticket product-detail-icon"></i>
            </div>
            <div className="col-10 col-lg-11">
              <hr />
            </div>
          </div>

          <h2>{product ? product.name : ''}</h2>
          <p>{product ? parse(product.description ?? '') : ''}</p>



          <form onSubmit={submitForm}>

            <ShopForm warn={isPrivate} />

            <ProductBase private={isPrivate} />

            <div className="fs-2 text-primary mb-4">
                {productPrice} Kč
            </div>

            <div className="row">
              <div className="col-3">
                <input onChange={(e) => setCount(e.target.value)} value={count} min="1" type="number" name="count" className="form-control form-control-lg" />
              </div>
              <div className="col-9">
                <button type="submit" className="btn btn-lg btn-primary rounded-pill" disabled={!!placeNotSelected && !isPrivate}>Přidat do košíku</button>
              </div>
            </div>
          </form>
        </div>

      </div>

      <div className="mb-5 pb-3">

      <TermsList private={isPrivate} id={id}/>

      </div>

    </div>

    <div className="bg-light">

      <div className="container py-5">
        <div className="row">
          <div className="col-12 col-lg-6 mb-3">
            <h2 className="text-primary mb-4">V ceně letenky získáte</h2>
            {propsList}
          </div>
          <div className="col-12 col-lg-6 custom-radius overflow-h">
            <ProductMap latitude={selectedPlace.latitude} longitude={selectedPlace.longitude}/>
          </div>
        </div>
      </div>

    </div>

    <Relations private={isPrivate}/>

    </div>
  );

}

export default ProductDetail;
